export default __webpack_public_path__ + "static/media/newTeleLogo.a160b075.svg";